import { SecurityType } from 'config/security'

export enum LD_TOGGLE_FEATURES {
  ENABLED_SECURITY_TYPES = 'ENABLED_SECURITY_TYPES',
  NEW_GRANT_FLOW = 'NEW_GRANT_FLOW',
  COMMUNICATIONS_FEATURE = 'COMMUNICATIONS_FEATURE',
  DISPLAY_NOTIFICATIONS = 'DISPLAY_NOTIFICATIONS',
  DISPLAY_CONTACT_PERMISSIONS_COLUMN = 'DISPLAY_CONTACT_PERMISSIONS_COLUMN',
  USE_PROXY_SA_DOCUMENT_FOR_GOVERNANCE_GROUPS = 'USE_PROXY_SA_DOCUMENT_FOR_GOVERNANCE_GROUPS',
  IMPROVE_SEARCH_IN_LIBRARY = 'IMPROVE_SEARCH_IN_LIBRARY',
  LAST_SHARE_PRICE_PARAMETER = 'LAST_SHARE_PRICE_PARAMETER',
  NOTIFICATION_AND_ACCESS_WORKFLOW_STEP = 'NOTIFICATION_AND_ACCESS_WORKFLOW_STEP',
}

export type LD_TOGGLE_FEATURES_TYPES = {
  [LD_TOGGLE_FEATURES.ENABLED_SECURITY_TYPES]: {
    enabledSecurityTypes: SecurityType[]
  }
  [LD_TOGGLE_FEATURES.USE_PROXY_SA_DOCUMENT_FOR_GOVERNANCE_GROUPS]: {
    governanceGroups: string[]
  }
  [LD_TOGGLE_FEATURES.NEW_GRANT_FLOW]: boolean
  [LD_TOGGLE_FEATURES.COMMUNICATIONS_FEATURE]: boolean
  [LD_TOGGLE_FEATURES.DISPLAY_NOTIFICATIONS]: boolean
  [LD_TOGGLE_FEATURES.DISPLAY_CONTACT_PERMISSIONS_COLUMN]: boolean
  [LD_TOGGLE_FEATURES.IMPROVE_SEARCH_IN_LIBRARY]: boolean
  [LD_TOGGLE_FEATURES.LAST_SHARE_PRICE_PARAMETER]: boolean
  [LD_TOGGLE_FEATURES.NOTIFICATION_AND_ACCESS_WORKFLOW_STEP]: boolean
}
